import { getSelectedAccount } from '@/redux/selectedAccountSlice';
import { Container } from '@mui/material';
import { useSelector } from 'react-redux';

const BuildingPageWrapper = ({ children }) => {
  const account = useSelector(getSelectedAccount);

  return (
    <Container key={account.AccountId} maxWidth="xxl">
      <Container key={account.AccountId} maxWidth="xxl">
        {children}
      </Container>
    </Container>
  );
};

export default BuildingPageWrapper;
